const SITE_URL = "https://api.bob.webify.pro"; 
const HOST_URL = "https://api.bob.webify.pro";
const API_AUTH_URL = HOST_URL + "/api";
const API_URL = HOST_URL + "/api/auth";

const MAP_KEY = "AIzaSyDW60oc6nhqpEQnH-Vimum6u5Y7_0PtPvY";
const OSMAP_KEY = "5b3ce3597851110001cf6248d4962582c0db44c587e45f759711099f";
const STRIPE_PUBLIC_KEY = "pk_test_51Jce9IHpoBXV9BEww3fV4DkiR1KGvz9rbBj652cxMqVpUR01V9Y0FeHTEp0R6K8EGUAPRGv3DLBXfUQO9IDZu5GA00yVVOZZss"; //admin@wabify.pro
const MAPKIT_CONFIG = {
  scriptUrl: "https://cdn.apple-mapkit.com/mk/5.x.x/mapkit.js",
  tokenEndpoint: API_AUTH_URL + "/clients/mapkey/generate"
};

// admin@wabify.pro
const PUSHER_APP_KEY = "6e2ba88c87dbe046fd71";
const PUSHER_APP_SECRET = "1fbea7905322aa197eca";
const PUSHER_APP_PORT = 443;
const PUSHER_APP_SCHEME = "https";
const PUSHER_APP_CLUSTER = "eu";
const PUSHER_APP_LOCALE = false;
const PUSHER_APP_FORCE_TLS = false;
const PUSHER_APP_AUTH_ENDPOINT = API_AUTH_URL + "/broadcasting/auth";

/**
 * Firebase — same project in both files; each native app has its own API_KEY + GOOGLE_APP_ID.
 * @see android/app/google-services.json → project_info + client[0]
 * @see ios/App/App/GoogleService-Info.plist
 */
const FIREBASE_PROJECT = {
  projectId: "bob-express-sos",
  storageBucket: "bob-express-sos.firebasestorage.app",
  messagingSenderId: "433338889767",
} as const;

/** Android app: google-services.json → client where package_name === com.bob.express */
const FIREBASE_ANDROID_APP = {
  appId: "1:433338889767:android:9cf7433d0e73ac32c40002",
  apiKey: "AIzaSyAfDezDmO9mhkZVrz7SCTGAkLi82LTpGSs",
} as const;

/**
 * iOS app: GoogleService-Info.plist → GOOGLE_APP_ID + API_KEY.
 */
const FIREBASE_IOS_APP = {
  appId: "1:433338889767:ios:6100d13ef802c8ccc40002",
  apiKey: "AIzaSyBB63dZZU93LgEe4vDKMdrb4iD_rdWHftQ",
} as const;

/**
 * Used by Firebase JS (`initializeApp` in main.ts, web + plugin web layer).
 * apiKey + appId must be from the same Firebase app; here we use the Android registration.
 * For a first-class web app, add one in Firebase Console and swap to that app’s apiKey/appId.
 */
export const firebaseConfig = {
  apiKey: FIREBASE_ANDROID_APP.apiKey,
  authDomain: `${FIREBASE_PROJECT.projectId}.firebaseapp.com`,
  projectId: FIREBASE_PROJECT.projectId,
  storageBucket: FIREBASE_PROJECT.storageBucket,
  messagingSenderId: FIREBASE_PROJECT.messagingSenderId,
  appId: FIREBASE_ANDROID_APP.appId,
};

export const environment = {
  servicesPhone: "+216 53406288",
  production: false,
  imagePath: HOST_URL + "",
  authUrl: API_URL,
  apiUrl: API_AUTH_URL,
  siteUrl: SITE_URL,

  map_key: MAP_KEY,
  osmap_key: OSMAP_KEY,
  mapkit: MAPKIT_CONFIG,
  stripe_public_key: STRIPE_PUBLIC_KEY,
  pusher: {
    authEndpoint: PUSHER_APP_AUTH_ENDPOINT,
    broadcaster: "pusher",
    forceTLS: PUSHER_APP_FORCE_TLS,
    locale: PUSHER_APP_LOCALE,
    key: PUSHER_APP_KEY,
    port: PUSHER_APP_PORT,
    scheme: PUSHER_APP_SCHEME,
    cluster: PUSHER_APP_CLUSTER,
    secret: PUSHER_APP_SECRET,
  },
  firebase: firebaseConfig,
};
